/** Only the server's explicit account-removal response triggers this flow. */
export function isRemovedAccountError(error: unknown) {
  return typeof error === 'object' && error !== null && 'code' in error && error.code === 'PT410'
}
